@use '../../css/base.scss';

:host {
  display: block;
  width: 100%;
}

.textarea {
  min-height: 300px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid var(--pv-color-gray-5);;
  padding: 14px;
  font-family: monospace;
  resize: vertical;
}

.controls {
  margin-top: calc(var(--pv-size-base) * 2);
  display: flex;
  flex-direction: column;
  gap: calc(var(--pv-size-base) * 2);
  margin-bottom: calc(var(--pv-size-base) * 12);
}

.control_row {
  display: flex;
  align-items: center;
  gap: var(--pv-size-base);
}
